import axios, { AxiosResponse } from 'axios';

const routeName = `/users`;
export async function getUsers(): Promise<any> {
    return axios.get(process.env.VUE_APP_CJ_API_URL + routeName)
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            return {error : err};
        });
}

export async function postUser(data: object): Promise<any> {
    return axios.post(process.env.VUE_APP_CJ_API_URL + routeName,data)
        .then(resp => {
            
            return {data: resp.data};
        })
        .catch(err => {
            return {error : err};
        });
}

export async function patchUser(data: any): Promise<any> {
    const id = data.user.id;
    if (data.user.sitesNamesConcat)
        delete data.user.sitesNamesConcat;
        
    return axios.patch(process.env.VUE_APP_CJ_API_URL + routeName+'/'+id,data)
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            return {error : err};
        });
}

export async function deleteUsers(dataToDelete: any[]): Promise<any> {
    const successData: any[] = [];
    const errorData: any[]= [];
    for (const prop in dataToDelete) {
        const data = dataToDelete[prop].user;

        await axios.delete(process.env.VUE_APP_CJ_API_URL +routeName+'/'+data.id)
            .then(resp => {
                successData.push(data);
            })
            .catch(err => {
                errorData.push(data);
            });
        }
    return {data: {successData: successData },
            error: {errorData: errorData}};
}